<template>
    <div class="ui-select-client">
        <ui-overlay-load v-if="load" />

        <div class="ui-no-content" v-if="!optionsComputed.length">
            <div class="title">
                <div>Cliente não encontrado. Deseja adicionar?</div>
                <ui-button design="md grey" @click="addNewClient"><i class="fal fa-plus"></i></ui-button>
            </div>
        </div>
        
        <template v-else>
            <div class="items-wrapper">
                <div class="items-scroller" ref="scroller">
                    <div class="items">
                        <div class="item"
                            v-for="option of optionsComputed"
                            :key="option.id_customer"
                            :class="{'current': option == selected}"
                            @click="select(option)">
                            <ui-badge :initials="option.name" v-if="option.name" :color="option !== selected ? '#adbcd7' : '#28a2ff'" :border="option !== selected" :radius="60" />

                            <div class="content">
                                <div class="item-name" v-if="option.name">{{ option.name }}</div>
                                <div class="item-email" v-if="option.email">{{ option.email }}</div>
                                <div class="item-phone" v-if="option.phone">{{ option.phone }}</div>
                            </div>

                            <i class="fal fa-check"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info">
                Você tem <span>{{ total || optionsComputed.length }} clientes </span> cadastrados
            </div>
        </template>
    </div>
</template>

<script>
    import uiBadge from "@/components/ui/badge"
    import { uiButton } from "@/components/ui/buttons"
    import { uiOverlayLoad } from '@/components/ui'

    export default {
        components: {
            uiBadge,
            uiButton,
            uiOverlayLoad,
        },

        props: {
            value: {
                type: Array,
                required: true,
                default () {
                    return []
                }
            },

            default: {
                type: Number,
                required: false,
                default: null,
            },

            load: {
                type: Boolean,
                required: false,
            },

            total: {
                type: Number,
                required: false,
                default: null
            }
        },

        data() {
            return {
                selected: null
            }
        },

        created: async function () {
            await this.$nextTick(() => {
                if (this.default && this.optionsComputed) {
                    this.selected = this.optionsComputed.find(option => option.id_customer === this.default)
                    this.$emit("input", this.selected)
                }
            })
        },

        mounted() {
            this.$refs.scroller.addEventListener('scroll', this.scrollHandler)
        },

        computed: {
            optionsComputed() {
                return this.value
            },

            selectedComputed: {
                get() {
                    return this.selected
                },
                set(value) {
                    this.selected = value
                    this.$emit('input', value)
                }
            },
        },

        methods: {
            select(option) {
                if (this.selectedComputed !== option) this.selectedComputed = option
                else {
                    this.selected = null
                    this.$emit('input', null)
                }
            },

            scrollHandler(event) {
                const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
                if (bottom) {
                    this.$emit('load-more')
                }
            },

            addNewClient() {
                this.$emit('add-new-client')
            }
        },

        watch: {
            value: async function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    this.selected = null
                    this.selectedComputed = null
                }
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>